$(function() {
    $('.load_more_jobs strong').text('Load more jobs');

    if ($('body').hasClass('single-job_listing') && $('[data-consultant-email]').data('consultant-email').length > 0) {
        $(document).find('.js-consultant input').val($('[data-consultant-email]').data('consultant-email'));
    }

    if ($('body').hasClass('single-job_listing') && $('[data-job]').data('job').length > 0) {
        $(document).find('.js-job input').val($('[data-job]').data('job'));
    }

    $('.form--search').on('submit', function(e) {
        e.preventDefault();
        var keywords = $(this).find('[name="search_keywords"]').val(),
            industry = $(this).find('#select1 :selected').val(),
            location = $(this).find('#select2 :selected').val();

        $('.job_filters').find('#search_keywords').val(keywords);
        $('.job_filters').find('#search_location').val(location);
        $('.job_filters').find('#search_categories').val(industry);
        $('.job_filters').find('#search_keywords').focus(); 
        $('.job_filters input[type="submit"]').trigger('click');
        $('.job_filters').trigger('submit');
        $('div.job_listings').triggerHandler('update_results', [
            1,
            !1
          ]);
    });

    // Resetting search results on page load - client request
    if($('body').hasClass('page-id-1166')) {
        var clearFilterOnLoad = setInterval(function() {
            if($('.js-search-results div.job_listings ul.job_listings').children().length > 0) {
                clearInterval(clearFilterOnLoad);
                $("#select1").val([]);
                $("#select2").val([]);
                if($('.showing_jobs').attr('style') == 'display: block;') {
                    $('.showing_jobs .reset').trigger('click');
                }
            }
        }, 100);
    }
   
});